const Header = ({ fixed = false, children }) => {
    return (
        <header>
            <nav className={`header-nav ${fixed ? "fixed" : ""}`}>
                {children}
            </nav>
        </header>
    )
}

export default Header;